export default __webpack_public_path__ + "static/media/Home_Light.0867d994.png";